import axios from 'axios';
import host from '../config';

let baseURL ;
if (process.env.NODE_ENV === 'development') {
    baseURL = host + '/infobiz-app/public/api/newsletter/'
} else {
    baseURL =  host + '/api/newsletter/';
}
const newsletterAxios = axios.create({
    baseURL
})

export default newsletterAxios;